class BroadcastService {
  open(namespace?: string): BroadcastChannel {
    return new BroadcastChannel(namespace || "general");
  }

  close(channel: BroadcastChannel): void {
    channel.close();
  }

  send(namespace: string, data: any): void {
    const bc = this.open(namespace);
    bc.postMessage(data);
    bc.close();
  }
}

const broadcastService = new BroadcastService();

export default broadcastService;
